// © Microsoft Corporation. All rights reserved.

// Constants for Cookie wall experience & helpers.
/**
 * Latest cookie statement document version. If the version of the cookie stamped on the client does not match this version,
 * the user is prompted again for consent.
 * IMPORTANT: Update this version whenever the cookie statement document gets updated.
 */
export const cookieStatementDocumentVersion = "v1";

/** Cookie name to store user's consent for cookie wall. The cookie gets dropped when user gives consent */
export const cacCookieName = "cac";

/**
 * CAC cookie domain.
 * Setting cookie domain to "msn.com" will cause the user agent
 * to send the cookie when making requests to "msn.com","www.msn.com" and "ntp.msn.com"
 * Reference: RFC spec: https://tools.ietf.org/html/rfc6265 "Domain" attribute section
 */
export const cacCookieDomain = "msn.com";

/** CAC cookie duration in days */
export const cacCookieDuration = 360;

/**
 * Id of mscc cookie banner container element.
 */
export const msccConsentBannerContainer = "consent-banner-container";

/** Cookie name to store user's consent for MSCC cookie banner. The cookie gets dropped by MSCC framework when user gives consent */
export const msccCookieName = "MSCC";

/**
 * The id of the <script> tag for the OneTrust SDK stub javascript inserted by PCS.
 */
export const OneTrustBannerScriptId = "onetrust-sdk";

/**
 * The OneTrust cookie category enum.
 */
export enum OneTrustCookieCategory {
    /** Strictly Necessary Cookies */
    C0001 = "C0001",

    /** Advertising Cookies */
    C0002 = "C0002",

    /** Social Media Cookies */
    C0003 = "C0003",

    /** 3rd Party Analytics */
    C0004 = "C0004"
}

/**
 * The OneTrust cookie name indicating consent status.
 */
export const OneTrustConsentCookieName = "eupubconsent-v2";

/**
 * The name of the window event fired by OneTrust script when consent status is available.
 */
export const OneTrustConsentEventName = "consent.onetrust";